import { UPDATE_OPERATORS_ERROR_CODE } from '../lib/apiErrorCodes';
import {
  SUCCESS_API_CREATE_OPERATOR,
  RESET_STAFF_CONFIRM_DATA,
} from '../actions/actionTypes';

const appInitialState = {
  userInfo: {},
  operators: [],
  searchOptions: {
    sort: 'asc',
  },
  openUpdateStaffDialog: false,
  confirmData: {},
  refreshPage: false,
  remoteMembers: [],
  namePartial: '',
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case 'UPDATE_TARGET_GROUP': {
      return { ...appInitialState };
    }
    case 'SUCCESS_API_GET_USER_INFO': {
      const userInfo = action.payload;
      return { ...state, userInfo };
    }
    case 'SUCCESS_API_GET_OPERATORS': {
      const operators = action.payload.operators || [];
      return { ...state, operators };
    }
    case 'OPEN_UPDATE_STAFF_DIALOG': {
      const openUpdateStaffDialog = true;
      const id = action.id || null;
      const confirmData =
        (state.operators && state.operators.find(p => p.operatorId === id)) ||
        {};
      return {
        ...state,
        confirmData,
        openUpdateStaffDialog,
      };
    }
    case 'CLOSE_UPDATE_STAFF_DIALOG': {
      const openUpdateStaffDialog = false;
      return { ...state, openUpdateStaffDialog };
    }
    case 'UPDATE_ROLE_SELECT': {
      const role =
        action.role !== null && action.role !== undefined
          ? Number(action.role)
          : null;
      const confirmData = { ...state.confirmData, role };
      return { ...state, confirmData };
    }
    case 'SUCCESS_API_UPDATE_OPERATORS': {
      const openUpdateStaffDialog = false;
      return {
        ...state,
        refreshPage: !state.refreshPage,
        openUpdateStaffDialog,
      };
    }
    case 'ERROR_API_UPDATE_OPERATORS_STATUS': {
      const results = action.payload.results || [];
      const errorCode =
        (results.length > 0 && results[0].errorCode) ||
        UPDATE_OPERATORS_ERROR_CODE.unknown;
      const userLicense =
        errorCode === UPDATE_OPERATORS_ERROR_CODE.overUserLicense;
      const remoteSupportLicense =
        errorCode === UPDATE_OPERATORS_ERROR_CODE.overRemoteSupportLicense ||
        errorCode === UPDATE_OPERATORS_ERROR_CODE.noRemoteSupportLicense;
      const updateOperatorsError = {
        userLicense,
        remoteSupportLicense,
        errorCode,
      };
      const confirmData = { ...state.confirmData, updateOperatorsError };
      return { ...state, confirmData };
    }
    case 'UPDATE_ACCOUNT_STATUS_SELECT': {
      const accountStatus =
        action.status !== undefined ? Number(action.status) : null;
      const confirmData = { ...state.confirmData, accountStatus };
      return { ...state, confirmData };
    }
    case 'UPDATE_REMOTE_SUPPORT_STATUS_SELECT': {
      const remoteSupportStatus =
        action.status !== undefined ? Number(action.status) : null;
      const confirmData = { ...state.confirmData, remoteSupportStatus };
      return { ...state, confirmData };
    }
    case 'OPERATOR_CHANGE_SORT': {
      const sort = state.searchOptions.sort === 'asc' ? 'desc' : 'asc';
      const searchOptions = {
        ...state.searchOptions,
        sort,
      };
      return { ...state, searchOptions };
    }
    case 'FILTER_OPERATOR_NAME': {
      const { namePartial } = action;
      return { ...state, namePartial };
    }
    case 'RESET_OPERATOR_INFO': {
      const { searchOptions, remoteMembers } = state;
      return { ...state, ...appInitialState, searchOptions, remoteMembers };
    }
    case 'CHECK_OPERATOR': {
      const { id } = action;
      const remoteMembers = state.remoteMembers.slice();
      let newCheckedIds;
      if (remoteMembers.some(({ operatorId }) => operatorId === id)) {
        // 選択肢から外す
        newCheckedIds = remoteMembers.filter(
          ({ operatorId }) => operatorId !== id,
        );
      } else {
        // 選択肢に追加する
        newCheckedIds = remoteMembers;
        const target =
          state.operators.find(({ operatorId }) => operatorId === id) || {};
        const name = target.name || '';
        newCheckedIds.push({ operatorId: id, name });
      }
      return { ...state, remoteMembers: newCheckedIds };
    }
    case 'RESET_CHECK_OPERATOR': {
      return { ...state, remoteMembers: appInitialState.remoteMembers };
    }
    case 'CHECK_ALL_OPERATOR': {
      const { checked } = action;
      const { operatorId: myOperatorId } = state.userInfo;
      let remoteMembers = state.remoteMembers.slice();
      if (checked) {
        const targetMembers = state.operators
          .filter(({ operatorId }) => {
            const exist = remoteMembers.some(
              member => member.operatorId === operatorId,
            );
            return operatorId !== myOperatorId && !exist;
          })
          .map(({ operatorId, name }) => ({ operatorId, name }));
        remoteMembers = remoteMembers.concat(targetMembers);
      } else {
        remoteMembers = remoteMembers.filter(
          ({ operatorId }) =>
            !state.operators.some(
              operator => operator.operatorId === operatorId,
            ),
        );
      }
      return { ...state, remoteMembers };
    }
    case SUCCESS_API_CREATE_OPERATOR: {
      return {
        ...state,
        refreshPage: !state.refreshPage,
      };
    }
    case RESET_STAFF_CONFIRM_DATA: {
      return {
        ...state,
        confirmData: action.payload,
      };
    }
    default:
      return state;
  }
};
